export const localStorageHelper = {
  load(key: string) {
    const stored = localStorage.getItem(key);
    return stored == null ? undefined : JSON.parse(stored);
  },
  store(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  modify(key: string, value: any) {
    this.store(key, value);
  },
  remove: (key: string) => {
    localStorage.removeItem(key);
  },
  clearLocalStorage: () => {
    localStorage.clear();
  },
};
